<template>
  <vs-popup class="add-additional-cost-popup"
            id="popup"
            :title="`PRODUCT ORDER ITEM STATUS LOG`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-table :data="activities"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

        <template slot="thead">
          <vs-th sort-key="contact_1">DATE/TIME</vs-th>
          <vs-th sort-key="name">USER</vs-th>
          <vs-th class="">DESCRIPTION</vs-th>
          <vs-th class="">STATUS CHANGE FROM</vs-th>
          <vs-th class="">STATUS CHANGE TO</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr  :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].updated_at">
              {{ __dateTimeFormatter(data[indextr].updated_at) }}
            </vs-td>
            <vs-td :data="data[indextr].causer_name">
              {{ data[indextr].causer_name }}
            </vs-td>

            <vs-td :data="data[indextr].description">
              <!--                    {{ data[indextr].is_active }}-->
              <vs-chip transparent v-if="data[indextr].description === 'created'"  color="primary">
                {{data[indextr].description}}
              </vs-chip>
              <vs-chip transparent v-if="data[indextr].description === 'updated'"  color="warning">
                {{data[indextr].description}}
              </vs-chip>
            </vs-td>

            <vs-td>
              {{ data[indextr].properties.old ? data[indextr].properties.old.item_status : 'N/A'}}
            </vs-td>

            <vs-td>
              {{ data[indextr].properties.attributes.item_status }}
            </vs-td>


          </vs-tr>
        </template>


      </vs-table>

    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const CustomerRepository = RepositoryFactory.get('customer')


  function initialState() {
    return {
      open: false,
      id: '',
      activities: [],
    }
  }

export default {
  name: 'ViewProductOrderItemLogPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        this.open = true;
        await this.fetchOrderItemLog()
      } catch (error) {

      }
    },
    async fetchOrderItemLog() {
      try {
        const { data } = (await CustomerRepository.getProductOrderItemLog(this.id)).data
        this.activities = data.filter((x) => {
          return x.properties && x.properties.attributes && x.properties.attributes.item_status
        })
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },

  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .add-additional-cost-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }
</style>
